import React, { Component } from "react";

import '../../style/category.css';
import '../../style/generic.css';
import HeroSectionCategory from "../Herosection/HeroSectionCategory.js";
import {  Link, useParams } from "react-router";
import * as Constanti from '../../Utils/constants.js';
import axios from "axios";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Protagonisti from "../protagonisti/protagonisti.js";
import CardThree from "../cards/cardThree.js";
import CardTwo from "../cards/cardTwo.js";
import YoutubeClass from "../youtube/youtube.js";


class DettaglioVideo extends Component{
  constructor(props){
    
    super(props);
    this.state = {
      video: {},
      correlati:[],
     titolo:"",
      "descrizione":"",
      "img":"",
      "page":1,
      "lastpage":1,
       videoUrl: '',
       isMobile: typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
       aperto: false,

      }
      this.caricaAltriVideo = this.caricaAltriVideo.bind(this);
      this.chiudiModal = this.chiudiModal.bind(this);
}

  componentDidMount() {
    this.fetchVideo(this.props.params.id);
  }

  componentDidUpdate(prevProps) {
    if (this.props.params.id !== prevProps.params.id) {
      this.fetchVideo(this.props.params.id);
    }
  }

  fetchVideo(id) {
    const api = Constanti.url_Backend + "getVideo";
    axios.post(api, { id_video: id })
      .then(res => {
        const v = res.data.data;
        this.setState({
          video: v,
          titolo: v.categorie.description,
          descrizione: v.title,
          img: v.thumbnail,
          page: 1,
          correlati: [],
        }, () => {
          this.loadRelated(v.categorie.id, 1);
        });
      })
      .catch(err => console.error(err));
  }

  loadRelated(idCat, page) {
    const api = Constanti.url_Backend + "getVideoByCategoryDetail";
    axios.post(api, { id_categoria: idCat, page, per_page: 8 })
      .then(res => {
        const { data, last_page } = res.data.data;
            const nextPage   = this.state.page + 1;
          this.setState(prev => ({
            page:  nextPage,
            correlati: [...(prev.correlati || []), ...data],
            load:  false,
           lastpage: last_page 
          }));
       // this.setState({ correlati: data, lastpage: last_page, page });
      })
      .catch(err => console.error(err));
  }

  caricaAltriVideo() {
    this.loadRelated(this.state.video.categorie.id, this.state.page + 1);
  }


 chiudiModal = (e) => {
    this.setState({ videoId: null });
  };
 

  handleInputChange = (e) => {
    this.setState({ videoUrl: e.target.value });
  };
 
  showVideo = (id) => {
    this.setState({ videoId: id });
  };

toggle = () => {
this.setState((prev) => ({ aperto: !prev.aperto }));
};

  render(){
    const {titolo,descrizione,img,video,correlati,page,lastpage,videoId,isMobile,aperto} = this.state;
    const limite = 200; // numero di caratteri da mostrare quando chiuso
    var testoMostrato ="";
    var mostraPulsante=false;
    if (video.descrizione != null && video.descrizione != ""){
 testoMostrato = aperto ? video.descrizione : video.descrizione.slice(0, limite);
 mostraPulsante = video.descrizione.length > limite;
}
    return (
    <>
  <HeroSectionCategory titolo={titolo} descrizione={descrizione} img={img} videoDetail={true} link={video.url} onShowVideo={this.showVideo} ></HeroSectionCategory>
  <section className="categoryDetail">
  <div className="container padding-top-48">
  {!isMobile && (video.personaggi && video.personaggi.length > 0 || video.descrizione) &&
  <Tabs>
  <TabList>
    {video.personaggi && video.personaggi.length > 0 && <Tab>I protagonisti</Tab>}
    {video.descrizione && <Tab>Descrizione</Tab>}
  </TabList>

  <TabPanel>
    {video.personaggi && video.personaggi.length > 0 && <Protagonisti protagonisti={video.personaggi} />}
  </TabPanel>
  <TabPanel>
    {video.descrizione && <h2>{video.descrizione}</h2>}
  </TabPanel>
</Tabs>
  }
  {isMobile && video.descrizione &&
   <div aria-expanded={aperto} className="descrizioneMobile">
    <p>
      {testoMostrato}
      {!aperto && video.descrizione.length > limite ? '...' : ''}
    </p>
    {mostraPulsante && (
      <button 
        onClick={this.toggle}
        aria-label={aperto ? 'Mostra meno testo' : 'Mostra altro testo'}
        style={{
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          marginTop: 4,
          textAlign:'left',
          fontFamily:'manrope',
          fontWeight:400,
          fontSize:'16px'
        }}
      >
        {aperto ? 'Show less' : 'Show more'}
      </button>
    )}
  </div>
  }
  {isMobile && video.personaggi && video.personaggi.length>0 &&
  <>
  <div className="protagonistiMobile">
    I protagonisti
  </div>
  <Protagonisti protagonisti={video.personaggi} />
    </>
  }

  <div className="padding-bottom-16 padding-top-80 align-left ">Ti potrebbero interessare anche...</div>
 <div className="grid padding-bottom-80">
    
     {correlati != null && correlati.length>0 && correlati?.map(el => (
      <div className="contenitoreCard" key={el.id}>
            <Link to={'/video/'+el.id}>
    <CardTwo thumbnail={el.thumbnail} title={el.title} data={el.created_at} isCat="true"></CardTwo>
     </Link>
    </div>
    ))}
  </div>
  { page < lastpage &&
  <div className="carica-altri padding-top-48 padding-bottom-48 ">
     <div onClick={this.caricaAltriVideo} className="caricaAltri button secondary small w-button">Carica altri</div>
  </div>
  }
  </div>
 
 </section>
  {videoId && (
      <div className="modal" id="myModal">
    <div className="modal-content">
       <span className="close" id="closeModal" onClick={this.chiudiModal}>&times;</span>
       <YoutubeClass videoId={videoId} />
    </div>
</div>
    )}
</>
    )
}
}

export default (props) => (
  <DettaglioVideo
      {...props}
      params={useParams()}
  />);